import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import { v4 as uuidv4 } from 'uuid';
import { isFocusable, keyCode } from '../../helpers';
import MegaMenuIntegratedTabs from './megaMenuIntegratedTabs';

class Module extends Component {
  setupDefaults() {
    this.handleEscape = this.handleEscape.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.ignoreUtilFocusChanges = false;
    this.dom = {
      html: document.querySelector('html'),
      body: document.querySelector('body'),
      pageContainer: document.querySelector('.page-container'),
      stickyMenu: this.el.querySelector('.header__sticky'),
      primaryLinkContainers: [
        ...this.el.querySelectorAll('.mega-menu__section')
      ],
      primaryLinks: this.el.querySelectorAll('.hamburger-menu__primary-link'),
      submenus: [...this.el.querySelectorAll('.mega-menu__submenu')],
      trigger: this.el.querySelector('.header__hamburger-menu-toggle'),
      triggerIconOpen: this.el.querySelector('.header__hamburger-menu-toggle-icon-open'),
      triggerIconClose: this.el.querySelector('.header__hamburger-menu-toggle-icon-close'),
      marker: this.el.querySelector('#marker'),
      menu: this.el.querySelector('.mega-menu'),
      primaryNav: this.el.querySelector('.hamburger-menu__primary-nav'),
      header: document.querySelector('.header'),
      tabs: [...this.el.querySelectorAll('.mega-menu-integrated-tab')],
      menusSmDevice: [...this.el.querySelectorAll('.mega-menu__submenu-smdevice')],
      drawer: this.el.querySelector('.mega-menu__sm-device'),
      primaryNavSmDevice: this.el.querySelectorAll('.mega-menu__primary-nav'),
      primaryNavLinks: this.el.querySelectorAll('.mega-menu__primary-link'),
      secondaryNav: [...this.el.querySelectorAll('.mega-menu__secondary-nav')],
      secondaryNavLinks: this.el.querySelectorAll('.mega-menu__secondary-nav-link'),
      tertiaryNav: [...this.el.querySelectorAll('.mega-menu__tertiary-nav')],
      back: this.el.querySelectorAll('.mega-menu__back.to-primary-nav, .mega-menu__back.to-secondary-nav'),
      videos: document.querySelectorAll('video')
    };
  }

  addListeners() {
    this.dom.primaryLinks.forEach((link, index) => {
      const guid = uuidv4();
      if (this.dom.submenus[index]) {
        this.dom.submenus[index].id = guid;
      }
      link.setAttribute('aria-controls', guid);
      link.addEventListener('click', this.handlePrimaryLinkSelect.bind(this));
    });

    this.dom.primaryNavLinks.forEach((link, index) => {
      const guid = uuidv4();
      if (this.dom.secondaryNav[index]) {
        this.dom.secondaryNav[index].id = guid;
      }
      link.setAttribute('aria-controls', guid);
      link.addEventListener('click', this.handlePrimaryLinkSelect.bind(this));
    });

    this.dom.secondaryNavLinks.forEach((link, index) => {
      const guid = uuidv4();
      if (this.dom.tertiaryNav[index]) {
        this.dom.tertiaryNav[index].id = guid;
      }
      link.setAttribute('aria-controls', guid);
      link.addEventListener('click', this.handlePrimaryLinkSelect.bind(this));
    });

    this.dom.back.forEach((backBtn, toPrimaryNav) => {
      toPrimaryNav = backBtn.classList.contains('to-primary-nav')
      backBtn.addEventListener('click', this.handleBackClick.bind(this, toPrimaryNav));
    });

    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  addEventListeners() {
    document.addEventListener('keyup', this.handleEscape);
    document.addEventListener('focus', this.handleFocus, true);
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  removeEventListeners() {
    document.removeEventListener('keyup', this.handleEscape);
    document.removeEventListener('focus', this.handleFocus, true);
  }

  handleBackClick(e) {
    if (e) {
      this.hideSubmenus();
    } else {
      const id = this.activeTertiaryNav.id;
      const secLinks = [...this.dom.secondaryNavLinks];
      const previousState = secLinks.find(
        secNav => secNav.getAttribute('aria-controls') === id
      )
      ?.parentElement;
      this.hideSubmenus();
      this.activeSecondaryNav = previousState;
      this.displayTertiaryNav(this.activeSecondaryNav);
    }
  }

  handlePrimaryLinkSelect(e) {
    const id = e.currentTarget.getAttribute('aria-controls');
    if (this.activeSubmenu && this.activeSubmenu.id === id ||
        this.activeSecondaryNav && this.activeSecondaryNav.id === id ||
        this.activeTertiaryNav && this.activeTertiaryNav.id === id
    ) {
      e.currentTarget.classList.remove('hamburger-menu__primary-link-selected');
      e.currentTarget.classList.remove('mega-menu__primary-link-selected');
      this.hideSubmenus();
    } else {
      this.dom.videos.forEach(video => {
        video.pause();
      });
      this.displaySubmenu(e.currentTarget);
    }
  }

  displaySubmenu(option) {
    this.hideSubmenus();
    this.dom.header.classList.add('mega-menu-open');
    const { scrollY } = window;
    //this.dom.body.style.top = `-${scrollY}px`;
    //this.dom.html.classList.add('is-scroll-locked');
    this.activeSubmenu = this.dom.submenus.find(
      submenu => submenu.id === option.getAttribute('aria-controls')
    );

    this.activeSecondaryNav = this.dom.secondaryNav.find(
      secNav => secNav.id === option.getAttribute('aria-controls')
    );

    this.activeTertiaryNav = this.dom.tertiaryNav.find(
      terNav => terNav.id === option.getAttribute('aria-controls')
    );

    option.classList.add('hamburger-menu__primary-link-selected');
    this.dom.marker.style.transition = '0.5s';
    this.dom.marker.style.width = `${option.offsetWidth}`+ 'px';
    this.dom.marker.style.left = `${option.offsetLeft}` + 'px';

    option.classList.add('mega-menu__primary-link-selected');

    if (this.activeSubmenu) {
      gsap.to(this.activeSubmenu, {
        height: 'auto',
        autoAlpha: 1,
        duration: 0.3
      });
    } else if (this.activeSecondaryNav) {
      gsap.to(this.dom.primaryNavSmDevice, {
        height: 0,
        autoAlpha: 0,
        duration: 0.3
      });

      gsap.to(this.activeSecondaryNav, {
        height: 'auto',
        autoAlpha: 1,
        duration: 0.3
      });
    } else if (this.activeTertiaryNav) {
      gsap.to(this.dom.primaryNavSmDevice, {
        height: 0,
        autoAlpha: 0,
        duration: 0.3
      });

      gsap.to(this.activeSecondaryNav, {
        height: 0,
        autoAlpha: 0,
        duration: 0.3
      });

      gsap.to(this.activeTertiaryNav, {
        height: 'auto',
        autoAlpha: 1,
        duration: 0.3
      });
    }
  }

  hideSubmenus() {
    this.dom.marker.style.transition = '0s';
    this.dom.marker.style.left = 0;
    this.dom.marker.style.width = 0;
    this.dom.header.classList.remove('mega-menu-open');
    this.dom.html.classList.remove('is-scroll-locked');

    if (this.activeSubmenu) {
      const tabs = [...this.activeSubmenu.querySelector('.mega-menu-integrated-tab').querySelectorAll('.mega-menu-integrated-tab__tab')];
      this.integratedTabs = new MegaMenuIntegratedTabs(this.activeSubmenu);
      this.integratedTabs.changePanel(tabs[0].getAttribute('aria-controls'));

      const links = [...this.dom.primaryLinks];
        links
          .find(link =>
            link.classList.contains('hamburger-menu__primary-link-selected')
          )
        ?.classList.remove('hamburger-menu__primary-link-selected');

        gsap.to(this.activeSubmenu, {
          height: 0,
          autoAlpha: 0,
          duration: 0.3
        });

        this.activeSubmenu = null;
    }

    if (this.activeSecondaryNav) {
      const links = [...this.dom.primaryLinks];
        links.find(link =>
          link.classList.contains('mega-menu__primary-link-selected')
        )
      ?.classList.remove('mega-menu__primary-link-selected');

        gsap.to(this.activeSecondaryNav, {
          height: 0,
          autoAlpha: 0,
          duration: 0.3
        });

        gsap.to(this.dom.primaryNavSmDevice, {
          height: 'auto',
          autoAlpha: 1,
          duration: 0.3
        });

        this.activeSecondaryNav = null;
    }

    if (this.activeTertiaryNav) {
      gsap.to(this.activeTertiaryNav, {
        height: 0,
        autoAlpha: 0,
        duration: 0.3
      });

      this.activeTertiaryNav = null;

      gsap.to(this.activeSecondaryNav, {
        height: 0,
        autoAlpha: 0,
        duration: 0.3
      });
    }
  }

  displayTertiaryNav(previousState) {
    gsap.to(previousState, {
      height: 'auto',
      autoAlpha: 1,
      duration: 0.3
    });
  }

  toggleDrawer() {
    if (this.el.classList.contains('header--hamburger-menu-open')) {
      this.closeDrawer();
      this.hideSubmenus();
      document.dispatchEvent(new Event('menuClose'));
    } else {
      this.openDrawer();
    }
  }

  openDrawer() {
    this.dom.trigger.classList.add('is-open');
    const tl = gsap.timeline();
    const { innerHeight, scrollY } = window;
    const { offsetTop } = this.dom.pageContainer;
    const headerHeight = this.dom.stickyMenu.offsetHeight;
    const difference = offsetTop - scrollY;
    this.dom.html.classList.add('is-scroll-locked');
    this.dom.body.style.top = `-${scrollY}px`;

    gsap.to(this.dom.triggerIconOpen, {
      opacity: 0,
      duration: 0.3,
      onComplete: () => {
        gsap.to(this.dom.triggerIconOpen, { display: 'none' });
        gsap.to(this.dom.triggerIconClose, { display: 'flex' });
        gsap.to(this.dom.triggerIconClose, {
          opacity: 1,
          duration: 0.3
        })
      }
    });

    this.el.classList.add('header--hamburger-menu-open');
    tl.set(this.dom.drawer, {
      height: 0,
      autoAlpha: 1
    });
    tl.to(this.dom.drawer, {
      height: `${innerHeight - headerHeight - (difference > 0 ? difference : 0)}px`,
      duration: 0.4
    });

    this.dom.primaryLinkContainers.forEach(link => {
      link.classList.remove('mega-menu__section--active');
      tl.from(link, { opacity: 0, duration: 0.12 });
    });

    this.dom.menusSmDevice.forEach(submenu => {
      submenu.classList.remove('mega-menu__submenu--active');
    });

    this.addEventListeners();
  }

  closeDrawer() {
    this.dom.trigger.classList.remove('is-open');
    const tl = gsap.timeline();
    this.el.classList.remove('header--hamburger-menu-open');
    this.dom.html.classList.remove('is-scroll-locked');

    gsap.to(this.dom.triggerIconClose, {
      opacity: 0,
      duration: 0.3,
      onComplete: () => {
        gsap.to(this.dom.triggerIconClose, { display: 'none' });
        gsap.to(this.dom.triggerIconOpen, { display: 'flex' });
        gsap.to(this.dom.triggerIconOpen, {
          opacity: 1,
          duration: 0.3
        })
      }
    });

    gsap.to(this.dom.drawer, {
      height: 0,
      autoAlpha: 0,
      duration: 0.4
    });

    gsap.to(this.dom.primaryNavSmDevice, {
      height: 'auto',
      autoAlpha: 1,
      duration: 0.3
    });

    this.removeEventListeners();
  }

  handleSubmenuNavigate(e) {
    if (this.ignoreUtilFocusChanges) return;

    const { activeElement } = document;
    const submenuLinks = [...this.activeSubmenu?.querySelectorAll('a')];
    const activeSubmenu = submenuLinks.indexOf(activeElement);

    switch (e.keyCode) {
      case keyCode.TAB:
        if (this.activeSubmenu && this.activeSubmenu.contains(activeElement)) {
          e.preventDefault();

          this.attemptFocus(
            this.dom.primaryLinks.find(
              link =>
                link.getAttribute('aria-controls') === this.activeSubmenu.id
            )
          );
        }
        break;
      case keyCode.RIGHT:
      case keyCode.DOWN:
        if (this.activeSubmenu && this.activeSubmenu.contains(activeElement)) {
          e.preventDefault();
          if (activeSubmenu === submenuLinks.length - 1) {
            this.focusFirstDescendant(this.activeSubmenu);
          } else {
            this.attemptFocus(submenuLinks[activeSubmenu + 1]);
          }
        }
        break;
      case keyCode.LEFT:
      case keyCode.UP:
        if (this.activeSubmenu && this.activeSubmenu.contains(activeElement)) {
          e.preventDefault();
          if (activeSubmenu === 0) {
            this.focusLastDescendant(this.activeSubmenu);
          } else {
            this.attemptFocus(submenuLinks[activeSubmenu - 1]);
          }
        }
        break;
    }
  }

  handleClickOutside(e) {
    this.breakpoint = matchMedia('(min-width: 1000px)');
    if (this.breakpoint.matches) {
      if (!this.dom.menu.contains(e.target) && (!this.dom.primaryNav.contains(e.target))){
        this.hideSubmenus();
      }
    }
  }

  focusFirstDescendant(element) {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  focusLastDescendant(element) {
    for (let i = element.childNodes.length - 1; i >= 0; i--) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  handleEscape(e) {
    const key = e.which || e.keyCode;

    if (key === keyCode.ESC) {
      e.stopPropagation();
    }
  }

  handleFocus(e) {
    if (
      this.ignoreUtilFocusChanges ||
      e.target.classList.contains('header__language-toggle') ||
      e.target.classList.contains('hamburger-menu__primary-link') ||
      e.target.classList.contains('header__search-toggle')
    )
      return;

    if (this.dom.drawer.contains(e.target)) {
      this.lastFocus = e.target;
    } else {
      this.focusFirstDescendant(this.dom.drawer);

      if (this.lastFocus === document.activeElement) {
        this.focusLastDescendant(this.dom.drawer);
      }
      this.lastFocus = document.activeElement;
    }
  }

  attemptFocus(element) {
    if (!isFocusable(element)) {
      return false;
    }

    this.ignoreUtilFocusChanges = true;
    try {
      element.focus();
    } catch (e) {
      return;
    }
    this.ignoreUtilFocusChanges = false;
    return document.activeElement === element;
  }

  handleResize() {
    const tl = gsap.timeline();
    const { innerHeight, scrollY } = window;
    const { offsetTop } = this.dom.pageContainer;
    const headerHeight = this.dom.stickyMenu.offsetHeight;
    const difference = offsetTop - scrollY;
    tl.to(this.dom.drawer, {
      height: `${innerHeight - headerHeight - (difference > 0 ? difference : 0)}px`,
      duration: 0.4
    });
    this.dom.marker.style.width = '0';
  }
}

export default Module;
